var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-change-password"},[_c('div',{staticClass:"header"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('user-change-password.title-page')))])]),_c('change-password-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }